export const region = {
    labels: {
        code: "Código",
        description: "Descrição",
        edit_region: "Editar Região",
        name: "Nome",
        region: "Região",
        regions: "Regiões",
        slug: "Slug",
    },
    placeholders: {
        code: "Exe: BR",
        description: "Informe a descrição",
        name: "Informe o nome",
        slug: "Exe: nome-da-url",
    },
    modals: {
        titles: {
            add_region: "Adicionar Região",
            edit_region: "Editar Região",
            del_region: "Excluir Região",
        },
        messages: {
            del_region: "Você deseja mesmo excluir o região <strong>{name}</strong>?<br/>Todos os relacionamentos desta região serão excluídas.",
        },
    },
    texts: {
    },
};
